import React, { useEffect, useState } from 'react'
import './add-customer.scss'
import NormalInput from '../../common/inputs/NormalInput'
import SelectInput from '../../common/inputs/SelectInput'
import { BiLoaderAlt } from 'react-icons/bi'
import { customerAxios } from '../../../config/axios'
import { toast } from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import InfoBox from '../../common/info-box/InfoBox'
import InputPhoneNumber from '../../common/inputs/InputMobileNumber'

const AddCustomer = () => {
    const [loading, setLoading] = useState('fetch')
    const [city, setCity] = useState([])
    const [pinCode, setPinCode] = useState([])
    const [post, setPost] = useState([])
    const [form, setForm] = useState({})
    const navigate = useNavigate()

    const handleChange = (e) => {


        if (e?.target?.name === 'city') {
            let selectedCity = null
            city?.map((obj) => {
                if (obj.city_id === e.target.value) {
                    selectedCity = obj
                }
                return obj;
            })

            setForm({
                ...form,
                city: selectedCity?.city_name,
                city_id: selectedCity?.city_id,
                state: selectedCity?.state_name,
                pin_code: '',
                post: '',

            })
            setPinCode(selectedCity?.pin_codes || [])
            setPost(selectedCity?.post_offices || [])

            return;
        }

        if (['contact_1', 'contact_2', 'whatsapp'].includes(e.name)) {
            setForm({
                ...form,
                [e?.name]: e?.number ? { country_code: e?.country_code || null, number: e?.number || null } : undefined
            })

            return;
        }

        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if (form.first_name?.[0] === ' ' || form.last_name?.[0] === ' ') {
            toast.error('Remove space from first name and last name')
            return;
        }

        if (form.first_name.length < 3) {
            toast.error('First name must have minimum 3 length')
            return;
        }

        if (form.contact_1?.number === form.contact_2?.number) {
            toast.error('Contact 1 and Contact 2 is Same')
            return;
        }


        setLoading('submit')
        customerAxios.post('/profile', form).then((response) => {
            toast.success('New Customer created')
            navigate(`/customer/${response.data.cid}/edit`)
            setLoading('')
        }).catch((error) => {
            toast.error(error.message)
            setLoading('')
        })

    }

    useEffect(() => {
        customerAxios.get('/l/area').then((response) => {
            setCity(response?.data || [])
        })
    }, [])

    return (
        <div className="create-customer-div">
           
            <form action="" onSubmit={handleSubmit}>
                <div className="inputs">
                    <NormalInput label='First name*' value={form?.first_name} name='first_name' onChangeFun={handleChange} />
                    <NormalInput label='Last name*' value={form?.last_name} name='last_name' onChangeFun={handleChange} />
                    <NormalInput label='Address' value={form?.address} name='address' onChangeFun={handleChange} isRequired={false} />
                    <NormalInput label='Place*' value={form?.place} name='place' onChangeFun={handleChange} />
                    <SelectInput label='City*' value={form?.city} name='city' values={city?.map((obj) => ({ option: obj?.city_name, value: obj?.city_id }))}
                        onChangeFun={handleChange}
                        firstOption={{ option: 'Choose...', value: '' }} isRequired={false} />
                    <NormalInput label='State*' value={form?.state} name='state' />
                    <SelectInput label='Post office*' name='post' onChangeFun={handleChange}
                        values={post?.map((value) => ({ option: value, value, selected: value === form?.post }))}
                        firstOption={{ option: 'Choose...', value: '' }} />
                    <SelectInput label='Pin code*' name='pin_code' onChangeFun={handleChange}
                        values={pinCode?.map((value) => ({ option: value, value, selected: value === form?.pin_code }))}
                        firstOption={{ option: 'Choose...', value: '' }} />
                    <NormalInput label='Land mark' value={form?.land_mark} name='land_mark' onChangeFun={handleChange} isRequired={false} />

                    <InputPhoneNumber label={'Primary Number'} value={`${form?.contact_1?.country_code || ''}${form?.contact_1?.number || ''}`}
                        onChange={handleChange} onlyCountries={['in']} country={'in'} name={'contact_1'} required />
                    <InputPhoneNumber label={'Secondary Number'} value={`${form?.contact_2?.country_code || ''}${form?.contact_2?.number || ''}`}
                        onChange={handleChange} country={'in'} name={'contact_2'} />
                    <InputPhoneNumber label={'Whatsapp Number'} value={`${form?.whatsapp?.country_code || ''}${form?.whatsapp?.number || ''}`}
                        onChange={handleChange} country={'in'} name={'whatsapp'} />


                    {/* <NormalInput label='My Care of ID' value={form?.care_of_id} name='care_of_id' onChangeFun={handleChange} isRequired={false} /> */}
                </div>

                <div className="button-div">
                    <button style={{ marginTop: '20px' }} disabled={loading === 'submit'} type='submit'>{loading === 'submit' ? <span className='loading-icon'><BiLoaderAlt /></span> : "Create New"}</button>
                </div>
            </form>
        </div>
    )
}

export default AddCustomer